/**
 * Converts a given string to sentence case.
 * The first word remains as is, while all subsequent words are converted to lowercase.
 *
 * @param text - The input string to be converted to sentence case.
 * @returns The input string transformed into sentence case.
 */
export const toSentenceCase = (text: string) => {
  return text
    .split(' ')
    .map((word, index) => (index === 0 ? word : word.toLowerCase()))
    .join(' ');
};

export const truncateText = (text?: string, maxLength: number = 30) =>
  text && text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

export const parseAmount = (value: string | number | null | undefined): number => {
  if (value === null || value === undefined) return 0;
  if (typeof value === 'number') return value;
  const normalized = value.replaceAll('.', '').replaceAll(',', '.');
  return Number.parseFloat(normalized) || 0;
};